import React from 'react';
import logo from '../assets/logo.svg';

const DownloadApp: React.FC = () => {
  return (
    <section id="download" className="min-h-screen bg-white flex items-center py-16">
      <div className="w-full px-[6vw]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">

          {/* Left: text */}
          <div>
            <p className="text-base font-bold tracking-[0.18em] text-gray-400 uppercase mb-5">
              Be the reason your loved ones smile back home
            </p>
            <h2
              className="font-black text-gray-900 leading-[1.05] mb-5"
              style={{ fontSize: 'clamp(2.4rem, 4.5vw, 4rem)' }}
            >
              Download<br />Smile Africa
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed max-w-sm mb-10">
              Easily buy and send airtime to your friends and family
              back home with the Smile Africa app.
            </p>

            <p className="text-base font-bold tracking-[0.18em] text-gray-400 uppercase mb-4">
              Smile Africa is available on
            </p>

            {/* Store badges */}
            <div className="flex flex-wrap gap-4">
              <a
                href="#download"
                className="flex items-center gap-3 bg-black hover:bg-gray-900 transition text-white rounded-xl px-5 py-3"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16.365 1.43c0 1.14-.462 2.06-1.14 2.75-.75.79-1.98 1.4-3.03 1.31-.13-1.11.44-2.27 1.14-3 .77-.83 2.11-1.44 3.03-1.06zM20.5 17.4c-.55 1.26-.81 1.82-1.51 2.93-.98 1.55-2.36 3.48-4.08 3.5-1.53.02-1.92-.99-4-.98-2.08.01-2.51 1-4.04.98-1.72-.02-3.03-1.76-4.01-3.3C.53 17.14-.42 12.5 1.14 9.36c.9-1.79 2.51-2.92 4.26-2.94 1.5-.02 2.92 1.01 3.84 1.01.92 0 2.64-1.25 4.45-1.06.76.03 2.89.3 4.26 2.3-.11.07-2.54 1.48-2.52 4.41.03 3.5 3.07 4.66 3.11 4.68-.03.08-.48 1.66-1.04 2.64z"/>
                </svg>
                <div className="text-left leading-tight">
                  <p className="text-[10px] uppercase tracking-wide text-gray-300">Download on the</p>
                  <p className="text-sm font-bold">App Store</p>
                </div>
              </a>
              <a
                href="#download"
                className="flex items-center gap-3 bg-black hover:bg-gray-900 transition text-white rounded-xl px-5 py-3"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M4 3.5v17l16-8.5-16-8.5z"/>
                </svg>
                <div className="text-left leading-tight">
                  <p className="text-[10px] uppercase tracking-wide text-gray-300">Get it on</p>
                  <p className="text-sm font-bold">Google Play</p>
                </div>
              </a>
            </div>
          </div>

          {/* Right: gradient banner + phone mockup */}
          <div className="relative" style={{ marginRight: '-6vw' }}>
            <div
              className="rounded-3xl flex items-center justify-center overflow-hidden relative"
              style={{
                background: 'linear-gradient(135deg, #f9540f 0%, #ea3d05 55%, #7c210f 100%)',
                minHeight: '440px',
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                marginLeft: '-4vw',
                width: 'calc(100% + 4vw)',
                padding: '2.5rem',
              }}
            >
              {/* subtle dotted pattern */}
              <div
                style={{
                  position: 'absolute', inset: 0, opacity: 0.15,
                  backgroundImage: 'radial-gradient(circle, white 1.5px, transparent 1.5px)',
                  backgroundSize: '22px 22px',
                }}
              />

              <div className="flex flex-col items-center gap-5 z-10">
                <div className="w-20 h-20 rounded-2xl bg-white flex items-center justify-center shadow-2xl">
                  <img src={logo} alt="Smile Africa" className="w-14 h-14 rounded-xl" />
                </div>
                <p className="text-white text-xl font-bold tracking-wide text-center">
                  Get instant airtime<br />top-ups on your phone
                </p>
              </div>

              {/* Phone mockup */}
              <div
                className="hidden lg:block"
                style={{
                  position: 'absolute', right: '2rem', top: '50%', transform: 'translateY(-50%)',
                  width: 'clamp(140px, 15vw, 200px)', aspectRatio: '9 / 18.5',
                  background: '#111', borderRadius: '1.6rem', padding: '8px',
                  boxShadow: '0 24px 48px rgba(0,0,0,0.35)',
                }}
              >
                <div
                  style={{
                    width: '100%', height: '100%', borderRadius: '1.2rem',
                    background: '#fff7f0', display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center', gap: '0.5rem', padding: '0.75rem',
                  }}
                >
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#ea3d05" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="6" y="2" width="12" height="20" rx="2.5" />
                    <path d="M11 18h2" />
                  </svg>
                  <div className="w-full h-2 rounded-full" style={{ background: '#ffd9bd' }} />
                  <div className="w-2/3 h-2 rounded-full" style={{ background: '#ffd9bd' }} />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default DownloadApp;
